import {Tab, Tabs, Box} from '@mui/material'
import React, {useEffect} from 'react'
import ResendInvites from './ResendInvites'

export default function ResendInviteTabs({survey, onAuduenceTabChange}) {
  const STAFF_SURVEY =
    survey.audience === 1 ||
    survey.audience === 3 ||
    survey.audience === 5 ||
    survey.audience === 7

  const PARENT_SURVEY =
    survey.audience === 2 ||
    survey.audience === 3 ||
    survey.audience === 6 ||
    survey.audience === 7

  const PUPIL_SURVEY =
    survey.audience === 4 ||
    survey.audience === 5 ||
    survey.audience === 6 ||
    survey.audience === 7

  const [tabs, setTabs] = React.useState([])
  const [tabValue, setTabValue] = React.useState(null)
  useEffect(() => {
    const tabs = []
    if (STAFF_SURVEY) {
      tabs.push({value: 1, label: 'Staff'})
    }
    if (PARENT_SURVEY) {
      tabs.push({value: 2, label: 'Parents'})
    }
    if (PUPIL_SURVEY) {
      tabs.push({value: 4, label: 'Students'})
    }
    setTabs(tabs)
    setTabValue(tabs[0].value)
  }, [survey])

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  function CustomTabPanel(props) {
    const {children, index, ...other} = props

    return (
      <div
        role="tabpanel"
        hidden={tabValue !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {tabValue === index && <Box sx={{p: 3}}>{children}</Box>}
      </div>
    )
  }
  return (
    <>
      <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => {
            setTabValue(newValue)
          }}
        >
          {tabs.map(tab => (
            <Tab
              {...a11yProps(tab.value)}
              value={tab.value}
              label={tab.label}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map(tab => (
        <CustomTabPanel index={tab.value}>
          <ResendInvites survey={survey} tabAudience={tabValue} />
        </CustomTabPanel>
      ))}
    </>
  )
}
